import React from "react";
import SkeletonElement from "./BasicSkeleton/SkeletonElement";

export default function LeaderBoardCardSkeleton() {
  return (
    <div
      className="awg-card"
      style={{
        padding: "10px",
      }}
    >
      <div className="d-flex" style={{ alignItems: "center", margin: "0" }}>
        <div className="awg-img-box" style={{ margin: "0" }}>
          <SkeletonElement style={{ margin: "0px !important" }} type="box" />
        </div>
        <div className="awg-info-box">
          <h5 style={{ width: "100px", height: "18px", margin: "0" }}>
            <SkeletonElement style={{ margin: "0px !important" }} type="box" />
          </h5>
          <div
            className={`class-type`}
            style={{ width: "70px", height: "20px", margin: "0" }}
          >
            <SkeletonElement style={{ margin: "0px !important" }} type="box" />
          </div>
          <div
            className="gangsta-sale"
            style={{ width: "70px", height: "22px", margin: "0" }}
          >
            <SkeletonElement
              style={{
                boxShadow: "-7px 8px 10px -11px rgba(0,0,0,1)",
              }}
              type="box"
            />
          </div>
        </div>
      </div>
      <div className="side awg-stat-box">
        <div
          className=" d-flex skill-stat"
          style={{ width: "70px", height: "22px", margin: "0" }}
        >
          <SkeletonElement type="box" />
        </div>
        <div className="skill-icon-box" style={{ zIndex: "0" }}>
          <SkeletonElement
            style={{
              position: "absolute",
              width: "28px",
              height: "28px",
              top: "0",
              zIndex: "1",
              borderRadius: "100%",
              overflow: "hidden",
            }}
            type="box"
          />{" "}
          <SkeletonElement
            style={{
              position: "absolute",
              width: "28px",
              zIndex: "2",
              top: "0",
              boxShadow: "-7px 8px 10px -11px rgba(0,0,0,1)",
              left: "15px",
              height: "28px",
              borderRadius: "100%",
              overflow: "hidden",
            }}
            type="box"
          />{" "}
          <SkeletonElement
            style={{
              position: "absolute",
              top: "0",
              zIndex: "3",
              left: "25px",
              width: "28px",
              height: "28px",
              boxShadow: "-7px 8px 10px -11px rgba(0,0,0,1)",
              borderRadius: "100%",
              overflow: "hidden",
            }}
            type="box"
          />{" "}
          <SkeletonElement
            style={{
              position: "absolute",
              width: "28px",
              boxShadow: "-7px 8px 10px -11px rgba(0,0,0,1)",
              left: "35px",
              zIndex: "4",
              top: "0",
              height: "28px",
              borderRadius: "100%",
              overflow: "hidden",
            }}
            type="box"
          />{" "}
          <SkeletonElement
            style={{
              position: "absolute",
              top: "0",
              zIndex: "5",
              width: "28px",
              boxShadow: "-7px 8px 10px -11px rgba(0,0,0,1)",
              left: "50px",
              height: "28px",
              borderRadius: "100%",
              overflow: "hidden",
            }}
            type="box"
          />
        </div>
      </div>
    </div>
  );
}
